import React from "react";

function LinksMeticCard({ totalLinks }) {
  return (
    <div className="rounded-xl bg-white dark:bg-accent-800 overflow-hidden min-w-[384px] relative w-full border border-primary-50 shadow-sm dark:border-none">
      <div className="md:px-20px px-16px py-16px">
        <span className="absolute top-0 bottom-0 right-0">
          <svg
            width="211"
            height="170"
            viewBox="0 0 211 170"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.8"
              d="M134.163 137.984L124.313 114.269C120.906 106.068 120.893 97.8766 124.272 89.6951C127.652 81.5136 133.442 75.7195 141.644 72.3129C149.845 68.9064 158.036 68.8928 166.218 72.2723C174.399 75.6518 180.194 81.4422 183.6 89.6436L193.45 113.358L181.593 118.284L171.743 94.5688C169.691 89.6282 166.217 86.1469 161.322 84.125C156.427 82.1031 151.509 82.1182 146.569 84.1704C141.628 86.2225 138.147 89.6961 136.125 94.591C134.103 99.4859 134.118 104.404 136.17 109.344L146.021 133.059L134.163 137.984ZM150.49 110.348L162.348 105.423L182.049 152.852L170.191 157.778L150.49 110.348ZM139.088 149.842L150.946 144.917L160.796 168.631C162.848 173.572 166.322 177.053 171.217 179.075C176.112 181.097 181.03 181.082 185.97 179.03C190.911 176.978 194.392 173.504 196.414 168.609C198.436 163.714 198.421 158.797 196.369 153.856L186.518 130.141L198.376 125.216L208.226 148.931C211.633 157.132 211.646 165.324 208.267 173.505C204.887 181.687 199.097 187.481 190.895 190.887C182.694 194.294 174.502 194.307 166.321 190.928C158.139 187.548 152.345 181.758 148.939 173.557L139.088 149.842Z"
              className="dark:fill-secondary-600 fill-secondary-400"
            />
            <g filter="url(#filter0_f_482_2396)">
              <path
                d="M117.629 158.916L104.016 125.795C99.3085 114.341 99.2898 102.9 103.96 91.4735C108.631 80.0468 116.633 71.9546 127.967 67.1968C139.302 62.439 150.622 62.4201 161.929 67.14C173.236 71.86 181.243 79.9472 185.951 91.4016L199.564 124.523L183.177 131.402L169.564 98.2803C166.728 91.3801 161.927 86.518 155.163 83.6941C148.398 80.8702 141.602 80.8913 134.774 83.7574C127.946 86.6236 123.135 91.4749 120.341 98.3114C117.546 105.148 117.567 112.016 120.403 118.916L134.016 152.038L117.629 158.916ZM140.193 120.318L156.58 113.439L183.807 179.682L167.42 186.561L140.193 120.318ZM124.436 175.477L140.823 168.598L154.436 201.72C157.272 208.62 162.073 213.482 168.837 216.306C175.602 219.13 182.398 219.109 189.226 216.243C196.054 213.376 200.865 208.525 203.659 201.689C206.454 194.852 206.433 187.984 203.597 181.084L189.984 147.962L206.371 141.084L219.984 174.205C224.691 185.659 224.71 197.1 220.04 208.526C215.369 219.953 207.367 228.045 196.033 232.803C184.699 237.561 173.378 237.58 162.071 232.86C150.764 228.14 142.757 220.053 138.049 208.598L124.436 175.477Z"
                className="dark:fill-secondary-600 fill-secondary-400"
              />
            </g>
            <defs>
              <filter
                id="filter0_f_482_2396"
                x="0.471405"
                y="-36.3858"
                width="323.057"
                height="372.772"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="50"
                  result="effect1_foregroundBlur_482_2396"
                />
              </filter>
            </defs>
          </svg>
        </span>
        <h1 className="dark:text-primary-400 text-base mb-10px text-accent-600 font-semibold">
          Links Total
        </h1>
        <div className="flex items-center md:gap-16px gap-10px">
          <h1 className="md:text-3xl text-2xl font-semibold dark:text-primary-200 text-secondary-600">
            {totalLinks}
          </h1>
          {/* <div className="flex gap-1 items-center py-[3px] px-[5px] dark:text-accent-700 text-white text-xs dark:bg-primary-400 bg-secondary-400 font-semibold">
            <span>
              <svg
                width="12"
                height="7"
                viewBox="0 0 12 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.816667 7L0 6.18333L4.31667 1.8375L6.65 4.17083L9.68333 1.16667H8.16667V0H11.6667V3.5H10.5V1.98333L6.65 5.83333L4.31667 3.5L0.816667 7Z"
                  className="dark:fill-accent-700 fill-white"
                />
              </svg>
            </span>
            <span>16%</span>
          </div> */}
        </div>
        <div className="flex mt-25px gap-16px">
          <div className="pe-16px border-e  dark:border-accent-500 border-primary-100">
            <p className="text-sm dark:text-primary-400 mb-2 leading-none text-accent-300">
              Today
            </p>
            <p className="dark:text-primary-300 text-secondary-600 leading-none">
              + <span className="font-semibold">{totalLinks}</span>
            </p>
          </div>
          <div className="pe-16px border-e  dark:border-accent-500 border-primary-100">
            <p className="text-sm dark:text-primary-400 mb-2 leading-none text-accent-300">
              This week
            </p>
            <p className="dark:text-primary-300 text-secondary-600 leading-none">
              + <span className="font-semibold">{totalLinks}</span>
            </p>
          </div>
          <div>
            <p className="text-sm dark:text-primary-400 mb-2 leading-none text-accent-300">
              This month
            </p>
            <p className="dark:text-primary-300 text-secondary-600 leading-none">
              + <span className="font-semibold">{totalLinks}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LinksMeticCard;
